import { useEffect, useState } from "react";
import { Button, Col, Dropdown } from "react-bootstrap";
import Chart from "react-apexcharts";
import AOS from "aos";
import "../../../../node_modules/aos/dist/aos";
import "../../../../node_modules/aos/dist/aos.css";
import * as moment from "moment";

export default function PerformanceChart({ trips }) {

    const [graphType, setGraphType] = useState("Distance vs Expense");
    const [tripData, setTripData] = useState({
        Distance: "0 km",
        Expense: "₹ 0",
        Customers: "0",
    });
    const [tripProcessedData, setTripProcessedData] = useState({});

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();
    

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    useEffect(() => {
        AOS.init({
            startEvent: "DOMContentLoaded",
            disable: function () {
                var maxWidth = 996;
                return window.innerWidth < maxWidth;
            },
            throttleDelay: 10,
            once: true,
            duration: 700,
            offset: 10,
        });
    });

    useEffect(() => {
        if (trips) {

            trips = trips.sort((a, b) => {
                return new Date(a.date) - new Date(b.date);
            })

            let distance = 0;
            let expense = 0;
            let customers = 0;
            let temp = {}
            trips.filter((k) => k.isCompleted).map((trip) => {
                distance += trip.totalDistance;
                expense += trip.totalExpense;
                customers += trip.totalNewCustomers;

                if (temp[moment(trip.date).format("DD/MM/YY")]) {
                    temp[moment(trip.date).format("DD/MM/YY")].totalDistance += trip.totalDistance;
                    temp[moment(trip.date).format("DD/MM/YY")].totalExpense += trip.totalExpense;
                    temp[moment(trip.date).format("DD/MM/YY")].totalNewCustomers += trip.totalNewCustomers;
                }else {
                    temp[moment(trip.date).format("DD/MM/YY")] = {
                        totalDistance: trip.totalDistance,
                        totalExpense: trip.totalExpense,
                        totalNewCustomers: trip.totalNewCustomers,
                    }
                }

            });
            setTripProcessedData(temp);
            setTripData({
                Distance: `${(distance / 1000).toFixed(2)} km`,
                Expense: `₹ ${expense}`,
                Customers: `${customers}`,
            });
        }
    }, [trips]);
    const chart1 = {
        options: {

            chart: {
                fontFamily:
                    '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                    },
                },
                sparkline: {
                    enabled: false,
                },
            },
            colors: colors,
            stroke: {
                curve: "smooth",
                width: 3,
            },
            yaxis: [
                {
                    seriesName: graphType.split(" vs ")[0],
                    show: true,
                    title: {
                        text: graphType.split(" vs ")[0],
                        style: {
                            color: "#8A92A6",
                        },
                    },
                    labels: {
                        show: true,
                        minWidth: 19,
                        // maxWidth: 19,
                        style: {
                            colors: "#8A92A6",
                        },
                        offsetX: 0,
                    },

                },
                {
                    opposite: true,
                    seriesName: graphType.split(" vs ")[1],
                    show: true,
                    title: {
                        text: graphType.split(" vs ")[1],
                        style: {
                            color: "#8A92A6",
                        },
                    },
                    labels: {
                        show: true,
                        minWidth: 19,
                        // maxWidth: 19,
                        style: {
                            colors: "#8A92A6",
                        },
                        offsetX: 0,
                    },
                }
            ],
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: true
            },
            xaxis: {
                labels: {
                    minHeight: 22,
                    maxHeight: 22,
                    show: true,
                    style: {
                        colors: "#8A92A6",
                    },
                },
                type: "date",
                lines: {
                    show: false, //or just here to disable only x axis grids
                },
                // categories: trips ? trips.filter((k) => k.isCompleted).map((trip) => {
                //     return trip.date;
                // }) : [],
            },
            grid: {
                show: true,
            },
            fill: {
                type: "gradient",
                gradient: {
                    shade: "dark",
                    type: "vertical",
                    shadeIntensity: 0,
                    gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
                    inverseColors: true,
                    opacityFrom: 0.4,
                    opacityTo: 0.1,
                    stops: [0, 50, 80],
                    colors: colors,
                },
            },
            tooltip: {
                enabled: true,
            },
        },
        series: [
            {
                name: graphType.split(" vs ")[0],
                data: Object.keys(tripProcessedData)?.length ? Object.keys(tripProcessedData).map((key) => {
                    if (graphType === "Distance vs Expense" || graphType === "Distance vs Customers") {
                        return {x: key, y: parseFloat(tripProcessedData[key].totalDistance / 1000).toFixed(2)};
                    }
                    return {x: key, y: parseFloat(tripProcessedData[key].totalExpense).toFixed(2)};
                }) : [],
            },
            {
                name: graphType.split(" vs ")[1],
                data: Object.keys(tripProcessedData)?.length ? Object.keys(tripProcessedData).map((key) => {
                    if (graphType === "Distance vs Customers" || graphType === "Expense vs Customers") {
                        return {x: key, y: tripProcessedData[key].totalNewCustomers};
                    }
                    return {x: key, y: parseFloat(tripProcessedData[key].totalExpense).toFixed(2)};
                }) : [],
            },
        ],
    };

    return (
        <Col md="12">
            <div className="card" data-aos="fade-up" data-aos-delay="800">
                <div className="flex-wrap card-header d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">{`Total ${graphType.split(" vs ")[0]} - ${tripData[graphType.split(" vs ")[0]]}`}</h4>
                        <p className="mb-0">{`Total ${graphType.split(" vs ")[1]} - ${tripData[graphType.split(" vs ")[1]]}`}</p>
                    </div>
                    <div className="d-flex align-items-center align-self-center">
                        <div className="d-flex align-items-center text-primary">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <g>
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="8"
                                        fill="currentColor"
                                    ></circle>
                                </g>
                            </svg>
                            <div className="ms-2">
                                <span className="text-gray">{graphType.split(" vs ")[0]}</span>
                            </div>
                        </div>
                        <div className="d-flex align-items-center ms-3 text-info">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <g>
                                    <circle
                                        cx="12"
                                        cy="12"
                                        r="8"
                                        fill="currentColor"
                                    ></circle>
                                </g>
                            </svg>
                            <div className="ms-2">
                                <span className="text-gray">{graphType.split(" vs ")[1]}</span>
                            </div>
                        </div>
                    </div>
                    <Dropdown>
                        <Dropdown.Toggle
                            as={Button}
                            variant="text-gray"
                            type="button"
                            id="dropdownMenuButtonSM"
                            
                        >
                            {graphType}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => setGraphType("Distance vs Expense")}>Distance vs Expense</Dropdown.Item>
                            <Dropdown.Item onClick={() => setGraphType("Distance vs Customers")}>Distance vs Customers</Dropdown.Item>
                            <Dropdown.Item onClick={() => setGraphType("Expense vs Customers")}>Expense vs Customers</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="card-body">
                    <Chart
                        options={chart1.options}
                        series={chart1.series}
                        type="area"
                        height="400"
                    />
                </div>
            </div>
        </Col>
    )
}